module.exports = __webpack_public_path__ + "img/1461466941.11fe6fe9.jpg";